const WarningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
    >
      <g clipPath="url(#clip0_489_6472)">
        <path
          d="M70.5607 52.4597L45.336 8.76869C41.2159 1.55106 30.7971 1.55106 26.6918 8.76869L1.45231 52.4597C-2.66781 59.6774 2.46011 68.6438 10.7745 68.6438H61.1496C69.4639 68.6438 74.6808 59.5884 70.5607 52.4597ZM35.9991 58.9512C33.8056 58.9512 31.9827 57.1282 31.9827 54.9348C31.9827 52.7413 33.8056 50.9184 35.9991 50.9184C38.1925 50.9184 40.0155 52.7413 39.9265 55.0385C40.0303 57.1282 38.1036 58.9512 35.9991 58.9512ZM39.6598 32.9855C39.4819 36.0978 39.2892 39.1953 39.1114 42.3077C39.0225 43.3155 39.0225 44.2343 39.0225 45.2273C38.9336 46.8724 37.6442 48.147 35.9991 48.147C34.354 48.147 33.0794 46.9613 32.9757 45.3162C32.7089 40.4699 32.4273 35.7125 32.1605 30.8662C32.0716 29.5916 31.9827 28.3022 31.879 27.0276C31.879 24.9231 33.0646 23.1891 34.9913 22.6407C36.918 22.1813 38.8298 23.1002 39.6598 24.9231C39.9414 25.5604 40.0303 26.1977 40.0303 26.9387C39.9414 28.9691 39.7487 30.9847 39.6598 32.9855Z"
          fill="#E62D38"
        />
      </g>
      <defs>
        <clipPath id="clip0_489_6472">
          <rect width="72" height="72" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default WarningIcon;
